import { z } from 'src/lib';
import { OperacionADCMFields } from './fields';
import { schemaEntityWithId } from 'src/types';

export const schemaOperacionADCM = z
    .object({
        [OperacionADCMFields.CodPais]: z.number(),
        [OperacionADCMFields.NombrePais]: z.string(),
        [OperacionADCMFields.CodUnidadNegocio]: z.number().nullable(),
        [OperacionADCMFields.UnidadNegocio]: z.string().nullable(),
        [OperacionADCMFields.CodSectorComercial]: z.number().nullable(),
        [OperacionADCMFields.SectorComercial]: z.string().nullable(),
        [OperacionADCMFields.FechaSolicitud]: z.coerce.date().nullable(),
        [OperacionADCMFields.FechaVencimiento]: z.coerce.date().nullable(),
        [OperacionADCMFields.CodEstado]: z.number(),
        [OperacionADCMFields.DescEstado]: z.string(),
        [OperacionADCMFields.FechaAprobacion]: z.coerce.date().nullable(),
        [OperacionADCMFields.FechaAlta]: z.coerce.date().nullable(),
        
        [OperacionADCMFields.IdUsuarioAlta]: z.number(),
        [OperacionADCMFields.NombreUsuarioAlta]: z.string(),
        [OperacionADCMFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionADCMFields.MailUsuarioAlta]: z.string(),
        [OperacionADCMFields.IdUsuarioUltMod]: z.number().nullable(),
        [OperacionADCMFields.NombreUsuarioUltMod]: z.string().nullable(),
        [OperacionADCMFields.ApellidoUsuarioUltMod]: z.string().nullable(),
        [OperacionADCMFields.MailUsuarioUltMod]: z.string().nullable(),

        // emisor
        [OperacionADCMFields.RazonSocialEmisor]: z.string().nullable(),
        [OperacionADCMFields.CodEmisorTipo]: z.number().nullable(),
        [OperacionADCMFields.DescEmisorTipo]: z.string().nullable(),
        [OperacionADCMFields.CodClienteTipo]: z.number().nullable(),
        [OperacionADCMFields.DescClienteTipo]: z.string().nullable(),
        [OperacionADCMFields.NroCuenta]: z.string().nullable(),
        [OperacionADCMFields.EmisorPreaprobado]: z.boolean().nullable(),
        [OperacionADCMFields.RatingCrediticioEmisor]: z.string().nullable(),
        [OperacionADCMFields.Legislacion]: z.string().nullable(),
        [OperacionADCMFields.InformacionAdicionalEmisor]: z.string().nullable(),
        
        // transaccion
        [OperacionADCMFields.CodTransaccionTipo]: z.number().nullable(),
        [OperacionADCMFields.DescTransaccionTipo]: z.string().nullable(),
        [OperacionADCMFields.Underwriting]: z.boolean().nullable(),
        [OperacionADCMFields.Bridgeloan]: z.boolean().nullable(),
        [OperacionADCMFields.Monto]: z.string().nullable(),
        [OperacionADCMFields.Moneda]: z.string().nullable(),
        [OperacionADCMFields.Fee]: z.string().nullable(),
        [OperacionADCMFields.DestinoFondos]: z.string().nullable(),

        // transaccion (DCM / ABS / ECM)
        [OperacionADCMFields.CuponTransaccion]: z.string().nullable(),
        [OperacionADCMFields.CadenciaPagoCupon]: z.string().nullable(),
        [OperacionADCMFields.PlazoVencimiento]: z.string().nullable(),
        [OperacionADCMFields.CadenciaAmortizacion]: z.string().nullable(),
        [OperacionADCMFields.ContratoExclusividad]: z.boolean().nullable(),
        [OperacionADCMFields.Colocadores]: z.string().nullable(),
        [OperacionADCMFields.Garantias]: z.string().nullable(),

        // underwriting
        [OperacionADCMFields.UnderWritingMonto]: z.number().nullable(),
        [OperacionADCMFields.UnderWritingFee]: z.number().nullable(),
        [OperacionADCMFields.UnderWritingObservaciones]: z.string().nullable(),

        // bridge loan
        [OperacionADCMFields.BridgeLoanMoneda]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanMonto]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanComisionEstructuracion]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanTasaInteres]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanPlazo]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanTipoAmortizacionCapital]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanFrecuenciaPagoInteres]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanGarantias]: z.boolean().nullable(),
        [OperacionADCMFields.BridgeLoanDetalleGarantias]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanDetalleAforo]: z.string().nullable(),
        [OperacionADCMFields.BridgeLoanPrecancelable]: z.boolean().nullable(),
        [OperacionADCMFields.BridgeLoanCondicionesPrecancelacion]: z.string().nullable(),

        
        [OperacionADCMFields.Observaciones]: z.string().nullable(),
        [OperacionADCMFields.EstadoFinalizado]: z.boolean(),
        [OperacionADCMFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionADCMFields.PermiteEliminarOperacion]: z.boolean(),
        [OperacionADCMFields.IdMensaje]: z.number().nullable(),

        // tipos virtuales para renderizar condicionalmente
        [OperacionADCMFields.CodVirtualCliente]: z.number().nullable(),
        [OperacionADCMFields.CodVirtualTransaccion]: z.number().nullable(),
        [OperacionADCMFields.CodVirtualEmisor]: z.number().nullable(),
    })
    .merge(schemaEntityWithId);

export type OperacionADCM = z.infer<typeof schemaOperacionADCM>;